import { CommonModule } from '@angular/common';
import { Component, Input, NgZone, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { BingoConfigProviderService, ConfirmMessageService, CustomButtonComponent, FeaturesClientConfig } from '@frontend/bingo/frontend-lib/core';
import {
    CurrencyPipe,
    LoadingIndicatorService,
    NavigationService,
    Page,
    ProductHomepagesConfig,
    ProductService,
    UserService,
} from '@frontend/vanilla/core';

import { TimerComponent } from '../../../components/timer/timer.component';
import { LoginService } from '../../../services/login-Service';
import { SessionPackageService } from '../../../services/session-package.service';
import { SessionBingoConfirmComponent } from '../confirm-model/sessionbingo-confirm.component';
import { SessionBingoMoreInfoComponent } from '../more-info/sessionbingo-moreinfo.component';

@Component({
    selector: 'bg-bingo-package-item',
    templateUrl: './package-item.component.html',
    imports: [CustomButtonComponent, CurrencyPipe, CommonModule, TimerComponent],
})
export class PackageItemComponent implements OnInit, OnDestroy {
    @Input() id: any;
    @Input() highlight?: boolean;

    isCozyUser: boolean = false;
    featuresConfig: FeaturesClientConfig;
    content: any = [];
    clientConfig: any;
    sessionCost = 0;
    savings: any;
    totalCost: any;
    globalClientConfig: any;
    fabGrabRoomIds: any[];
    isPackageBingo: boolean;
    isSessionBingo: boolean;
    isInGameClient: boolean = false;
    disableButton: boolean = false;
    PurchaseButton: boolean;
    isLegacy: boolean = false;
    packageInfo: any;
    _loadingIndicator: any;

    constructor(
        private configProviderService: BingoConfigProviderService,
        private sessionService: SessionPackageService,
        private dialog: MatDialog,
        private productService: ProductService,
        private page: Page,
        public zone: NgZone,
        private user: UserService,
        public loginService: LoginService,
        private lhProductHomepagesConfig: ProductHomepagesConfig,
        private confirmMessageService: ConfirmMessageService,
        private navigator: NavigationService,
        private loadingIndicatorService: LoadingIndicatorService,
    ) {
        this.featuresConfig = this.configProviderService.provideFeaturesConfig();
    }
    ngOnInit(): void {
        if (localStorage.getItem('config')) {
            this.clientConfig = JSON.parse(localStorage.getItem('config')!);
        }
        this.isCozyUser = this.featuresConfig.enableNewCozyLobby;
        this.content = this.clientConfig?.packageGlobalMessages;
        this.sessionService.bingoGameMappings = this.clientConfig?.pageConfig?.value?.bingoGameMappings;
        this.fabGrabRoomIds = [];
        if (!this.globalClientConfig) this.globalClientConfig = this.clientConfig.global;
        this.packageInfo = this.sessionService.packageInfo[this.id];
        if (this.sessionService.packageInfo[this.id].type == 'package_bingo') {
            this.isPackageBingo = true;
            this.content = this.clientConfig?.packageGlobalMessages;
        }
        if (this.packageInfo.type == 'session_bingo') {
            this.isSessionBingo = true;
            this.content = this.clientConfig?.sessionGlobalMessages;
        }
        if (this.globalClientConfig.messages.fabGrabRoomIds) {
            this.fabGrabRoomIds = this.globalClientConfig.messages.fabGrabRoomIds.split(',').map((item: any) => {
                return parseInt(item, 10);
            });
        }
        if (this.loginService.packageBingoforcedData && this.packageInfo.id == this.loginService.packageBingoforcedData.id) {
            this.packageInfo.selectedDiscount = this.loginService.packageBingoforcedData.data.selectedDiscount;
        }
        if (this.loginService.sessionBingoforcedData && this.packageInfo.id == this.loginService.sessionBingoforcedData.id) {
            this.packageInfo.selectedDiscount = this.loginService.sessionBingoforcedData.data.selectedDiscount;
        }
        this.setCostSummary();
    }

    setCostSummary() {
        const discount_info = this.packageInfo.package_discount_info;
        if (this.packageInfo.isPurchased) {
            let ticketsPurchased = this.packageInfo.purchase_status.no_of_tickets;
            let discount = 0;
            let index = 0;
            for (let i = 0; i < discount_info.length; i++) {
                if (discount_info[i].number_of_tickets == ticketsPurchased) {
                    index = i;
                    discount = discount_info[i].discount;
                }
            }
            this.getCostSummary(ticketsPurchased, discount, index, true);
        } else {
            try {
                const selectedDiscount = discount_info.findIndex((item: any) => !item.Disabled);
                this.packageInfo.selectedDiscount = selectedDiscount == 0 ? 0 : selectedDiscount - 1;
            } catch (error) {
                this.packageInfo.selectedDiscount = 0;
            }
            this.getCostSummary(
                this.packageInfo.package_discount_info?.[this.packageInfo.selectedDiscount || 0]?.number_of_tickets,
                this.packageInfo.package_discount_info?.[this.packageInfo.selectedDiscount || 0]?.discount,
                this.packageInfo.selectedDiscount || 0,
            );
        }
        console.log(JSON.stringify(this.content));
    }

    moreInfoClicked() {
        const packageData = {
            id: this.packageInfo.id,
            type: this.packageInfo.type,
        };
        this.sessionService.iconClick(this.packageInfo.package_game_details[0].room_name, 'click', 'more info', 'package_bingo');

        const productInfo: any = this.productService.getMetadata('bingo');
        let apiUrl: string = '';
        if (productInfo) {
            if (this.isPackageBingo) {
                this.loginService.storepackageBingoForcedUrl(productInfo.apiBaseUrl + '/' + this.page.lang + '/bingo/packagebingo');
                this.loginService.storepackageBingoForcedData({
                    id: this.packageInfo.id,
                    type: this.packageInfo.type,
                    triggerType: 'moreInfo',
                    data: this.packageInfo,
                });
            } else {
                this.loginService.storesessionBingoForcedUrl(productInfo.apiBaseUrl + '/' + this.page.lang + '/bingo/sessionbingo');
                this.loginService.storesessionBingoForcedData({
                    id: this.packageInfo.id,
                    type: this.packageInfo.type,
                    triggerType: 'moreInfo',
                    data: this.packageInfo,
                });
            }
            apiUrl = productInfo.apiBaseUrl + '/' + this.page.lang + '/bingo/rooms';
        }
        const valid = this.loginService.validateUser(apiUrl);
        if (valid) {
            this.dialog.open(SessionBingoMoreInfoComponent, {
                panelClass: 'sessionbingo-moreinfo-popup',
                disableClose: true,
                data: {
                    sessionData: packageData,
                },
            });
            this.loginService.clearnBingoforcedUrl();
        }
    }

    buyNowClicked() {
        const productInfo: any = this.productService.getMetadata('bingo');
        let apiUrl: string = '';
        if (productInfo) {
            if (this.isPackageBingo) {
                this.loginService.storepackageBingoForcedUrl(productInfo.apiBaseUrl + '/' + this.page.lang + '/bingo/packagebingo');
                this.loginService.storepackageBingoForcedData({
                    id: this.packageInfo.id,
                    type: this.packageInfo.type,
                    data: this.packageInfo,
                    triggerType: 'buyNow',
                });
            } else {
                this.loginService.storesessionBingoForcedUrl(productInfo.apiBaseUrl + '/' + this.page.lang + '/bingo/sessionbingo');
                this.loginService.storesessionBingoForcedData({
                    id: this.packageInfo.id,
                    type: this.packageInfo.type,
                    data: this.packageInfo,
                    triggerType: 'buyNow',
                });
            }
            apiUrl = productInfo.apiBaseUrl + '/' + this.page.lang + '/bingo/rooms';
        }
        const valid = this.loginService.validateUser(apiUrl);
        if (valid) {
            this._loadingIndicator = this.loadingIndicatorService.start();
            this.zone.run(() => {
                this.sessionService.getPackageDetails(this.packageInfo.type, this.id).subscribe(
                    (response: any) => {
                        this._loadingIndicator.done();
                        if (response) {
                            this.sessionService.onPackageInfoFromPackagesData(this.id, response);
                            this.packageInfo = this.sessionService.getPackageInfo(this.id);
                            if (this.featuresConfig.enableScreenNameForPrebuy && !this.user.screenname) {
                                const url = window.location.href;
                                this.navigator.goTo(this.lhProductHomepagesConfig.portal + '/mobileportal/screenname', {
                                    appendReferrer: url,
                                });
                            } else {
                                const no_of_tickets = this.packageInfo.selectedTickets;
                                const game_name = this.packageInfo.game_details[0].game_Info[0].room_name;
                                let errCount = 0;
                                if (this.isSessionBingo && this.packageInfo?.game_details[0].isFabGrabRoom) {
                                    this.packageInfo.game_details[0].game_Info.forEach((element: any) => {
                                        if (
                                            element.game_context.FomoBingo.fomo_numbers?.length < element.game_context.FomoBingo.minimum_numbers ||
                                            element.game_context.FomoBingo.fomo_numbers == null
                                        ) {
                                            errCount++;
                                        }
                                    });
                                } else {
                                    this.packageInfo.game_details.forEach((rooms: any) => {
                                        if (rooms.isFabGrabRoom) {
                                            rooms.game_Info.forEach((element: any) => {
                                                if (
                                                    element.game_context.FomoBingo.fomo_numbers?.length <
                                                        element.game_context.FomoBingo.minimum_numbers ||
                                                    element.game_context.FomoBingo.fomo_numbers == null
                                                ) {
                                                    errCount++;
                                                }
                                            });
                                        }
                                    });
                                }
                                if (errCount > 0) {
                                    const message = this.globalClientConfig.messages.MinimumTopAndTailNumber,
                                        header = this.globalClientConfig.messages.fabGrabAlertHeader,
                                        closeBtn = this.globalClientConfig.messages.confirmCloseButton;
                                    this.confirmMessageService.confirmThis(
                                        header,
                                        message,
                                        '',
                                        '',
                                        closeBtn,
                                        () => {},
                                        () => {},
                                    );
                                } else {
                                    const dialogRef = this.dialog.open(SessionBingoConfirmComponent, {
                                        panelClass: 'sessionbingo-confirm-popup',
                                        disableClose: true,
                                        data: {
                                            sessionId: this.id,
                                            roomId: this.sessionService.packageInfo[this.id].package_game_details[0].room_id,
                                            game_name,
                                            package_type: this.packageInfo.type,
                                            gameDetails: this.sessionService.packageInfo[this.id].game_details,
                                            totalPrice: this.totalCost,
                                            SelectedTickets: this.sessionService.packageInfo[this.id].selectedTickets,
                                            packagePurchased: this.packageInfo.packagePurchased,
                                        },
                                    });
                                    this.sessionService.buySessionAandPackage(this.packageInfo.type, 'click', game_name, no_of_tickets);
                                    // dialogRef.afterClosed().subscribe(() => {});
                                    dialogRef.afterClosed().subscribe((res) => {
                                        // received data from dialog-component
                                        console.log(res);
                                        console.log('received data from dialog-component');
                                        // this.packageInfo.packagePurchased = res.isPurchased;
                                        if (this.sessionService.packageInfo[this.id].purchase_status) {
                                            this.packageInfo.purchase_status = { ...this.sessionService.packageInfo[this.id].purchase_status };
                                        }
                                        this.packageInfo.staus_of_package = this.sessionService.packageInfo[this.id]?.staus_of_package || 'active';
                                        this.packageInfo.packagePurchased = this.packageInfo.staus_of_package == 'purchased' ? true : false;
                                        this.packageInfo.isPurchased = this.packageInfo.staus_of_package == 'purchased' ? true : false;
                                        this.setCostSummary();
                                    });
                                }
                            }
                        }
                    },
                    () => {
                        this._loadingIndicator.done();
                    },
                );
            });
        }
    }

    getCostSummary(noOfTickets: number, discount: number, i: number, override?: boolean) {
        this.sessionService.packageInfo[this.id].selectedTickets = noOfTickets;
        const noOfTicketsBought = this.packageInfo?.purchase_status?.total_purchased_tickets
            ? this.packageInfo?.purchase_status?.total_purchased_tickets
            : 0;
        let maxValuePackageDiscount = this.packageInfo?.package_discount_info[this.packageInfo?.package_discount_info.length - 1]?.number_of_tickets;
        maxValuePackageDiscount = maxValuePackageDiscount ? maxValuePackageDiscount : 0;
        const maxTicketsFlag = override ? true : maxValuePackageDiscount - noOfTicketsBought >= noOfTickets;
        this.updateDisabledInPackageInfo(maxValuePackageDiscount, noOfTicketsBought);
        if ((!this.packageInfo.isPurchased || override) && maxTicketsFlag) {
            //code for grey out condition when feed is present/not present case
            if (this.packageInfo.isPurchased) {
                if (this.featuresConfig.sessionBingoMaxPurchaseEnable) {
                    this.sessionService.packageInfo[this.id].selectedDiscount = 0; //when feed present
                } else {
                    this.sessionService.packageInfo[this.id].selectedDiscount = i; //when feed not present
                }
            } else this.sessionService.packageInfo[this.id].selectedDiscount = i;
            this.packageInfo.selectedDiscount = i;
            this.sessionCost = 0;
            // for (let k = 0; k < this.package_game_details.length; k++) {
            //     this.sessionCost += (this.package_game_details[k].card_cost * noOfTickets);
            // }
            this.packageInfo.package_game_details.forEach((item: any) => {
                this.sessionCost += item.card_cost * noOfTickets;
            });
            this.sessionCost = Math.round((this.sessionCost + Number.EPSILON) * 100) / 100;
            this.savings = (this.sessionCost * discount).toFixed(2);
            this.totalCost = this.sessionCost - Number(this.savings);
            this.totalCost = Math.round((this.totalCost + Number.EPSILON) * 100) / 100;
        }
    }

    updateDisabledInPackageInfo(maxValuePackageDiscount: any, noOfTicketsBought: any) {
        for (let i = 0; i < this.sessionService.packageInfo[this.id].package_discount_info.length; i++) {
            if (maxValuePackageDiscount - noOfTicketsBought >= this.sessionService.packageInfo[this.id].package_discount_info[i].number_of_tickets) {
                this.sessionService.packageInfo[this.id].package_discount_info[i].Disabled = false;
            } else {
                this.sessionService.packageInfo[this.id].package_discount_info[i].Disabled = true;
            }
        }
        this.packageInfo.package_discount_info = this.sessionService.packageInfo[this.id].package_discount_info;
    }

    private readonly entrypointactive = (customEvent: CustomEvent) => {
        if (customEvent?.detail?.activeFrom && customEvent.detail.activeFrom.toLowerCase() === 'bottom-sticky') {
            dispatchEvent(new CustomEvent('gs:hideFloatingEntry'));
        }
    };

    ngOnDestroy(): void {
        if (this.isInGameClient) {
            dispatchEvent(new CustomEvent('gs:showFloatingEntry'));
            removeEventListener('gs:productstub:entrypoint:active', this.entrypointactive);
        }
    }
}
